import React from 'react';
import axios from 'axios';
import Authentication from '../helpers/Authentication'
import { reduxForm, change, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import { load, save, findById, update } from '../components/certificates/design/MeterDesignCertificate.Reducers';
import AuthorityHolderDetailsFormSection from '../components/certificates/common/AuthorityHolderDetailsFormSection';
import ApprovalDetailsFormSection from '../components/certificates/common/ApprovalDetailsFormSection';
import MeterDesignCertificatePartCForm from '../components/certificates/design/MeterDesignCertificatePartC';
import MeterDesignCertificatePartDForm from '../components/certificates/design/MeterDesignCertificatePartD';
import MeterDesignCertificateConfirmation from '../components/certificates/design/MeterDesignCertificateConfirmation';
import {  getMeterNumbers, deleteDraftForm } from '../components/certificates/common/MeterCertificateCommon';
import SearchCustomerForCertificates from '../components/certificates/common/SearchCustomerForCertificates';
import $ from 'jquery';
import DisplayForRoles from '../components/tools/DisplayForRoles'
import MeterEquipInfoAudit from '../components/certificates/common/MeterEquipInfoAudit'
import CertificateFiles from '../components/certificates/common/CertificateFiles'
import CertificateAdmin from '../components/certificates/common/CertificateAdmin'
import uiHelpers from '../helpers/uiHelpers'
import {StepProgressBar} from '../components/tools/BootstrapControls'

import {uploadOptionsForDesignCert as uploadOptions} from '../constants/MeterFormConstants'
import ReApplyConsentNotice from '../components/common/ReApplyConsentNotice'
import { userRole, addUserRoleUpdateNotifier } from '../helpers/userHelpers';

const authentication = new Authentication();

class MeterDesignCertificate extends React.Component {

  #currentUserEmail;
  #currentUserId;

  ajaxConfig = {
    baseURL: process.env.REACT_APP_WEBAPI_URL,
    headers: { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authentication.getToken() }
  };

  constructor(props) {
    super(props)
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.#currentUserEmail = authentication.currentUser().emails;
    this.state = {
      page: 0,
      validationDate: new Date(),
      meterReadingDate: new Date(),
      showInstructions: false,
      status: 1,
      meteringCircumstanceOptions:
        [
          { id: "1", name: "I have an existing validation that was done by a duly qualified person.", selected: false },
          { id: "2", name: "I have a manufacturer’s certificate.", selected: false },
          { id: "3", name: "I have an accuracy certificate provided by a duly qualified person.", selected: false }
        ],
      data: {},
      confirmingSubmission : false,
      tab : 'MAIN'
    }

    addUserRoleUpdateNotifier(() => {
      if(userRole.isSuperAdmin){
        this.forceUpdate();
      }
    });
  }

  async componentDidMount() {
    const currentContxt = this;
    axios.post('users/getprofile', JSON.stringify({ email: this.#currentUserEmail }), this.ajaxConfig).then(response => {
      currentContxt.#currentUserId = response.data.data.user.user.id;
      currentContxt.pageRefresh();
      
    }).catch(function (error) {
      console.log(error);
      uiHelpers.showErrorTop('Error occurred when reading your user info');
    });

    $(document).on( "keypress","[name='approvedWorkDetails.waterSupplyWorkApprovalNo']", function(e) {
      if(e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });

    
  }

  pageRefresh = async(meterDesignId = null,page) =>{
    let search = window.location.search;
    let params = new URLSearchParams(search);

    if(!meterDesignId){
      meterDesignId = params.get('id');
    }
    if (meterDesignId != null) {
      try {

        if(page) {
          this.setState({ page : parseInt(page)});
        } else {
          this.setState({ page: this.state.page + 1 });
        }
        

        
        uiHelpers.showProgressOnTop("Getting/Refreshing certificate data...");
        this.props.dispatch(change(this.props.form, 'loading', true));

        await this.props.dispatch(findById(meterDesignId));

        uiHelpers.hideProgressOnTop();
        this.props.dispatch(change(this.props.form, 'loading', false));

        if (
          this.props.approvedWorkDetails.approvedByCustomer == 1
          && this.props.approvedWorkDetails.waterSupplyWorkApprovalNo
          && this.props.approvedWorkDetails.esid
          && this.props.approvedWorkDetails.waterSupplyWorkApprovalNo != ""
          && this.props.approvedWorkDetails.esid != ""
        ) {
          uiHelpers.showProgressOnTop("Getting meter data...");
          this.props.dispatch(change(this.props.form, 'loading', true));
          var payloadData = await getMeterNumbers(this.props.approvedWorkDetails.waterSupplyWorkApprovalNo,this.props.approvedWorkDetails.esid);
          uiHelpers.hideProgressOnTop();
          this.props.dispatch(change(this.props.form, 'loading', false));

          if (payloadData.success)
            this.props.dispatch(change(this.props.form, 'meterNumberExternalList', payloadData.meterNumberExternalLists));
          else
            uiHelpers.showErrorTop("Error occured when getting meter data", true, false);
        }
      } catch (error) {
        uiHelpers.hideProgressOnTop();
        uiHelpers.showErrorTop("Error when getting data...", true, false);
      }
    } else {
      try {
        uiHelpers.showProgressOnTop("Loading data...");
        this.props.dispatch(change(this.props.form, 'loading', true));
        await this.props.dispatch(load());
        uiHelpers.hideProgressOnTop();
        this.props.dispatch(change(this.props.form, 'loading', false));
      } catch (error) {
        uiHelpers.hideProgressOnTop();
        uiHelpers.showErrorTop("Error when getting data...", true, false);
      }
    }
  }

  nextPage = (values) => {
    //console.log("MeterDesignPage" + values.clickSaveDraft + "next--" + values.clickNext);
    this.saveDraft(values);
  }

  saveDraft = (values) => {
    if (parseInt(values.clickSaveDraft) === 1 && parseInt(values.clickNext) === 0) {
      //console.log("MeterDesignPage:saving draft");
      try {
        uiHelpers.showProgressOnTop("Saving your record...");
        this.props.dispatch(change(this.props.form, 'loading', true));
        if (values.meteringEquipmentInformation.id > 0)
          this.props.dispatch(update(values, this.state.page, this.pageRefresh));
        else
          this.props.dispatch(save(values, this.state.page, this.pageRefresh));
      } catch (error) {
        console.log(error);
        this.props.dispatch(change(this.props.form, 'loading', false));
        uiHelpers.showErrorTop("Error occurred while saving the record")
      }

    } else if (parseInt(values.clickSaveDraft) === 0 && parseInt(values.clickNext) === 1 && values.meteringEquipmentInformation.formStatus == 2) {

      try {
        uiHelpers.showProgressOnTop("submitting your record...");
        this.props.dispatch(change(this.props.form, 'loading', true));
        if (values.meteringEquipmentInformation.id > 0)
          this.props.dispatch(update(values, this.state.page, this.pageRefresh));
        else
          this.props.dispatch(save(values,this.state.page, this.pageRefresh));
      } catch (error) {
        console.log(error);
        this.props.dispatch(change(this.props.form, 'loading', false));
        uiHelpers.showErrorTop("Error occurred while saving the record")
      }
    } else {
      if(values.meteringEquipmentInformation.formStatus==2) {
        this.setState({ page: this.state.page + 1 });
      } else if(this.state.page == 3 && !this.state.confirmingSubmission )
        this.setState({ confirmingSubmission: true });
      else if(this.state.page == 3 && this.state.confirmingSubmission )
        this.setState({ confirmingSubmission: false, page: this.state.page + 1 });
      else 
        this.setState({ page: this.state.page + 1 });
    }

  }

  previousPage = (formStatus) => {
      if(formStatus && formStatus == 2) {
        this.setState({ page: this.state.page - 1 });
      } else if(this.state.page==4) {
        this.setState({ page: this.state.page - 1, confirmingSubmission: true });
      } else {
        this.setState({ page: this.state.page - 1 });
      }
    
  }

  cancelConfrimSubmission = () => {
    this.setState({ confirmingSubmission: false });
  }

  cancelConfrimSubmissionAndGoToPage = (page) => {
    this.setState({ confirmingSubmission: false, page: page });
  }

  HideShow = () => {
    this.setState({ showInstructions: !this.state.showInstructions });
  }

  deleteDraft = ()=>{
    if (this.props.meterEquipInfo.id != 0) {
    let currentContext = this;
      deleteDraftForm(
        parseInt(this.props.meterEquipInfo.id)
        , function(){
          currentContext.props.dispatch(change(currentContext.props.form, 'loading', true));
        }
        , function(){
          window.location = 'Home';
        }
        , function(){
          
        }
        , function(error) {
          console.log(error);
          uiHelpers.showErrorTop('Error occurred when trying to delete the draft record ', true, false);
          currentContext.props.dispatch(change(currentContext.props.form, 'loading', false));
        }
      );
    } else {
      uiHelpers.showErrorTop('You are accessing this function in a invalid way', true, false);
    }
  }

  render() {
    const { page, showInstructions, meteringCircumstanceOptions, confirmingSubmission } = this.state
    const { form, loading, consentValid } = this.props;

    const needReApplyConsent = !userRole.isSuperAdmin && (this.props.meterEquipInfo && this.props.meterEquipInfo.formStatus==1 && consentValid===false && !(this.props.meterEquipInfo.createdBy && this.props.meterEquipInfo.createdBy.id != this.#currentUserId)) ? true : null;

    return <>
        <h3 className='mb-3'>Meter Design Certificate</h3>
        <p>
          <a className="btn btn-primary" onClick={this.HideShow}>Privacy and Glossary</a>
        </p>

        {showInstructions && (<div class="card card-body fs-90 mb-5">
          <h5>Privacy Statement</h5>
          <p>
            The personal information you provide on this form is subject to the Privacy & Personal Information
            Protection Act 1989. It is being collected by NSW Department of Planning, Industry and Environment and
            will be used for purposes related to the NSW non-urban water metering policy.
            NSW Department of Planning, Industry and Environment may disclose your personal information to the
            Natural Resources Access Regulator and WaterNSW. NSW Department Planning, Industry and Environment
            will not disclose your personal information to anybody else unless authorised by law.
            The provision of this information is required to be supplied under the Water Management Act 2000.
            If you choose not to provide the requested information you may be in breach of the conditions of your
            water supply work approval, access licence, or licence or other entitlement under the Water Act 1912.
            You have the right to request access to, and correct details of, your personal information held by the
            department. Further information regarding privacy can be obtained from NSW Department of Planning,
            Industry and Environment website at dpie.nsw.gov.au/privacy or by contacting us at
            patiunit@planning.nsw.gov.au.
          </p>
          <h5>Glossary of terms</h5>
          <p>
            The new metering requirements are prescribed in the Water Management Act 2000 (WM Act) and the Water Management (General) Regulation 2018, and are set out in the NSW Non-Urban Water Metering Policy. This glossary explains terms in the regulations that are used in this form.<br />
            <strong>Application day </strong> means the day the mandatory metering equipment condition applies to an authority—i.e. your roll-out date. [Clause 228 (1)]<br />
            <strong>Authority</strong> means a water supply work approval, an access licence, or a licence or other entitlement under the Water Act 1912. [Clause 228 (1)]<br />
            <strong>Certified meter installer</strong> is a person who holds a current certification as a meter installer issued by Irrigation Australia Ltd. It is a category of duly qualified person. [Clause 236 (1)]<br />
            <strong>Certified practising hydrographer</strong>is a person who is listed as a certified practising hydrographer in the register of certified professionals kept by the Australian Hydrographers Association. [Clause 236 (1)]<br />
            <strong>Duly qualified person</strong> is a person that has the following qualifications, skills and experience to carry out specified work in connection with metering equipment: (a) certified meter installer (b) certified practising hydrographer (c) metering system designer, or (d) telemetry technician. [Clause 236 (2)]<br />
            <strong>Faulty metering equipment</strong> means metering equipment that is not operating properly or is not operating. [Clause 240]<br />
            <strong>Existing validation</strong> means that the metering equipment installed before 1 April 2019 was validated by a duly qualified person in accordance with AS 4747: (a) within five years before the application day for the equipment, or (b) within 12 months before the application day for the equipment in the case of metering equipment that is installed in connection with an open channel. [Clause 8 of Schedule 8]<br />
            <strong>Maintenance specifications</strong> set out the requirements for how metering equipment must be maintained. They are published in the NSW Government Gazette and on the NSW Department of Industry website. [Clause 2 (4) of Schedule 8]<br />
            <strong>Open channel</strong> means a channel or conduit used for conveying water that is not enclosed. [Clause 228 (1)]<br />
          </p>
        </div>)}

        
        
       
        {!confirmingSubmission && page === 0 && <SearchCustomerForCertificates form={form} onSubmit={this.nextPage} />}


      
        {page > 0 && this.props.meterEquipInfo && <>
          <div class="card mb-3">
            <div class="card-body row">
                <div className='col-md-3'>
                  <label class="form-label">Record ID</label>
                  <input type="text" disabled={true} class="form-control" value={this.props.meterEquipInfo.id == 0 ? "Not saved" : this.props.meterEquipInfo.id} />
                </div>
                <div className='col-md-3'>
                  <label class="form-label">Form Status</label>
                  <input type="text" disabled={true} class="form-control" value={this.props.meterEquipInfo.formStatus==1?'Draft' : 'Submitted'} />
                </div>
                <div className='col-md-3'>
                  <label class="form-label">DQP</label>
                  <input type="text" disabled={true} class="form-control" value={this.props.meterEquipInfo.createdBy ? (this.props.meterEquipInfo.createdBy.firstName + " " + this.props.meterEquipInfo.createdBy.lastName) : ""} />
                </div>
            </div>
          </div>

          <ul class="nav nav-tabs mb-4">
              <li class="nav-item ">
                <a class={`nav-link ${this.state.tab == 'MAIN'?'active':''}`} aria-current="page" href="#"
                    onClick={(e)=>{e.preventDefault(); this.setState({ tab : 'MAIN'}); }}
                >Record details</a>
              </li>
              <li class="nav-item">
                <a class={`nav-link ${this.state.tab == 'AUDIT'?'active':''}`} href="#"
                    onClick={(e)=>{e.preventDefault(); this.setState({ tab : 'AUDIT'}); }}
                >Audit/Logs</a>
              </li>
              {this.props.meterEquipInfo.formStatus == 2 && <DisplayForRoles roles={{superAdmin : true, isCFOAdmin:true}}>
                <li class="nav-item">
                    <a class={`nav-link ${this.state.tab == 'FILES'?'active':''}`} href="#"
                      onClick={(e)=>{e.preventDefault(); this.setState({ tab : 'FILES'}); }}
                    >Files</a>
                </li>
              </DisplayForRoles>}
              {this.props.meterEquipInfo.formStatus == 2 && <DisplayForRoles roles={{superAdmin : true}}>
                <li class="nav-item">
                    <a class={`nav-link ${this.state.tab == 'ADMIN'?'active':''}`} href="#"
                      onClick={(e)=>{e.preventDefault(); this.setState({ tab : 'ADMIN'}); }}
                    >Admin</a>
                </li>
              </DisplayForRoles>}
          </ul>

          {this.state.tab == 'AUDIT' && <MeterEquipInfoAudit id={this.props.meterEquipInfo.id} /> }
          
          {this.state.tab == 'FILES' && <DisplayForRoles roles={{superAdmin : true, isCFOAdmin:true}}>
              <CertificateFiles 
                form={form} 
                certificateNameForSelector="meteringEquipmentInformation"
                fileTypeResolver={(document)=>{
                  var option = uploadOptions.filter(option=>option.id==document.documentType)[0];
                  return <>{option?option.name:""}</>
                }}
              />
          </DisplayForRoles> }
  
          {this.state.tab == 'ADMIN' && this.props.meterEquipInfo.formStatus == 2 && <DisplayForRoles roles={{superAdmin : true, isCFOAdmin:true}}>
            <CertificateAdmin id={this.props.meterEquipInfo.id} entityType="DesignCertificate" />
          </DisplayForRoles> }

          {this.state.tab == 'MAIN' && <>

            {needReApplyConsent && <ReApplyConsentNotice approvalNumber={this.props.approvedWorkDetails.waterSupplyWorkApprovalNo} />}

            {this.props.meterEquipInfo.formStatus == 1 && this.props.meterEquipInfo.createdBy && this.props.meterEquipInfo.createdBy.id != this.#currentUserId && <div className='alert alert-primary'>
              This form is owned by <strong>{this.props.meterEquipInfo.createdBy.firstName} {this.props.meterEquipInfo.createdBy.lastName}</strong> and cannot be edited
            </div>}

            <div className='my-5'>      
              <StepProgressBar 
                totalSteps={5} 
                currentStep={confirmingSubmission? 4 : page==4?5:page} 
                disableFutureSteps={this.props.meterEquipInfo.formStatus == 1} 
                stepClick={(page) =>{this.setState({page : page==5?4:page==4?3:page, confirmingSubmission : page==4  })}}/>
            </div>
            {!confirmingSubmission && page === 1 && <AuthorityHolderDetailsFormSection form={form} onSubmit={this.nextPage} disableEditing={(this.props.meterEquipInfo.createdBy && this.props.meterEquipInfo.createdBy.id != this.#currentUserId) || needReApplyConsent} />}
            {!confirmingSubmission && page === 2 && <ApprovalDetailsFormSection form={form} onSubmit={this.nextPage} previousPage={this.previousPage}  disableEditing={(this.props.meterEquipInfo.createdBy && this.props.meterEquipInfo.createdBy.id != this.#currentUserId) || needReApplyConsent} />}
            {!confirmingSubmission && page === 3 && <MeterDesignCertificatePartCForm form={form} onSubmit={this.nextPage} previousPage={this.previousPage} meteringCircumstanceOptions={meteringCircumstanceOptions} disableEditing={(this.props.meterEquipInfo.createdBy && this.props.meterEquipInfo.createdBy.id != this.#currentUserId)  || needReApplyConsent} />}
            {
              confirmingSubmission && 
              <MeterDesignCertificateConfirmation 
                form={form}
                onSubmit={this.nextPage} 
                cancelConfrimSubmissionAndGoToPage={this.cancelConfrimSubmissionAndGoToPage} 
                cancelConfrimSubmission={this.cancelConfrimSubmission} 
                disableEditing={(this.props.meterEquipInfo.createdBy && this.props.meterEquipInfo.createdBy.id != this.#currentUserId)  || needReApplyConsent}
              />
            }
            {page === 4 && <MeterDesignCertificatePartDForm form={form} onSubmit={this.nextPage} previousPage={this.previousPage} status={this.state.status} disableEditing={(this.props.meterEquipInfo.createdBy && this.props.meterEquipInfo.createdBy.id != this.#currentUserId) || needReApplyConsent} />}
          </>}
          
        </>}




        

        {/* start the delete draft dialog */}
        <div class="modal fade" id="deleteDraftModal" tabindex="-1" role="dialog" aria-labelledby="deleteDraftModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
               <div class="modal-content">
                  <div class="modal-header">
                     <button type="button" id="deleteDraftModalCloseBtn"  disabled={loading} class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <strong>Are you sure you want to delete this draft version of the form?</strong>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" disabled={loading} data-bs-dismiss="modal">Cancel</button>
              
                    <button type="button" class="btn btn-primary"
                      onClick={() => { this.deleteDraft(); }}
                      disabled={loading}
                    >Confirm deletion</button>
                    
                  </div>
               </div>
            </div>
         </div>
         {/* end the delete draft dialog */}


    </>;
  }
}

MeterDesignCertificate = reduxForm({
  enableReinitialize: true,
})(MeterDesignCertificate)

MeterDesignCertificate = connect(
  (state, props) => ({
    initialValues: state.reducerMeterDesign,
    loaded: state.reducerMeterDesign.loaded,
    form: props.form,
    approvedWorkDetails: formValueSelector(props.form)(state, 'approvedWorkDetails'),
    authorityHolderDetails: formValueSelector(props.form)(state, 'authorityHolderDetails'),
    showSpinner: formValueSelector(props.form)(state, 'showSpinner'),
    meterEquipInfo : formValueSelector(props.form)(state, 'meteringEquipmentInformation'),
    loading : formValueSelector(props.form)(state, 'loading'),
    consentValid : formValueSelector(props.form)(state, 'consentValid')
  }), {
  load: load,
  save: (payload) => save(payload),
  findById: (id) => findById(id),
  update: (payload) => update(payload)
}
)(MeterDesignCertificate)

export default MeterDesignCertificate;

